import { FC } from 'react';
import { HarmSignsListProps } from './harmReports.type';

export const HarmSignsList: FC<HarmSignsListProps> = (props) => {
  return (
    <div>
      <span className="text-[#7C7AA8] text-xs">{props.title}</span>
      {props.items.length ? (
        <ul className="list-disc list-inside">
          {props.items.map((item, index) => (
            <li key={index} className="text-xs">
              {item}
            </li>
          ))}
        </ul>
      ) : (
        <div>-</div>
      )}
    </div>
  );
};
